/**
 * 제안요청서 — 공고 첨부를 데이터로. 백엔드 `modules/rfp` 와 같은 모양.
 *
 * 담을 때 베낀 스냅샷의 첨부를 서버가 받아 텍스트로 뽑고(pdf · hwpx · docx), 배점표 · 사업 기간 · 지정 목차를 AI 가 뽑아 사람이 검수한다.
 * `.hwp`(5.0) 는 변환기가 없어 「불가」.
 */
export const RFP_FILE_KINDS = ['제안요청서', '입찰공고문', '과업지시서', '계약조건', '평가기준', '기타'] as const;
export type RfpFileKind = (typeof RFP_FILE_KINDS)[number];

export const TEXT_STATUSES = ['대기', '완료', '실패', '불가'] as const;
export type TextStatus = (typeof TEXT_STATUSES)[number];

export const TEXT_STATUS_STYLE: Record<TextStatus, string> = {
  '대기': 'bg-slate-100 text-slate-500',
  '완료': 'bg-emerald-50 text-emerald-700',
  '실패': 'bg-red-50 text-red-600',
  '불가': 'bg-amber-50 text-amber-700',
};

export interface RfpFile {
  id: number;
  projectId: number;
  fileKind: RfpFileKind;
  fileName: string;
  sourceUrl: string;
  mimeType: string | null;
  fileSize: number | null;
  sha256: string | null;
  downloadedAt: string | null;
  textStatus: TextStatus;
  textError: string | null;
  pageCount: number | null;
  textChars: number;
  extractedAt: string | null;
}

/** 배점표 한 줄 — 평가항목(배점) · 평가요소 · 배점. 기관마다 이름이 다르다 */
export interface EvalItem {
  id: number;
  rfpFileId: number | null;
  category: string;
  item: string;
  points: number | null;
  pageNo: number | null;
  sortOrder: number;
  extractedBy: string | null;
  /** 사람이 확인했나. 확인 전엔 「검수 필요」 · 다시 뽑아도 안 덮인다 */
  reviewed: boolean;
}

/** 「배점표 뽑기」 결과 — 저장된 것 + 저장하지 않는 참고(사업 기간 · 지정 목차 · 제출 형식) */
export interface ExtractResult {
  evalItems: EvalItem[];
  period: string | null;
  mandatedToc: string[];
  submitFormat: string | null;
  notes: string;
  filesRead: string[];
  kept: number;
}

export interface RfpPageText { pageNo: number; text: string }

/** 첨부 한글 문서에서 그대로 읽은 표 — 칸 주소 · 병합까지 (AI 없음, 2026-10-16) */
export interface DocTableCell { row: number; col: number; rowSpan: number; colSpan: number; text: string }
export interface DocTable { rows: number; cols: number; cells: DocTableCell[] }
export interface ScoreTableFile { fileId: number; fileName: string; tables: DocTable[] }
